var $3ee762802ba9edfd$exports = {};
$3ee762802ba9edfd$exports = {
    "clear": `Kirkas`,
    "invalid": `(ep\xe4kelpo)`,
    "loading": `Ladataan...`,
    "noResults": `Ei tuloksia`,
    "valid": `(kelvollinen)`
};


export {$3ee762802ba9edfd$exports as default};
//# sourceMappingURL=fi-FI.module.js.map
